'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ModalLayout = require('./ModalLayout.less');

var _ModalLayout2 = _interopRequireDefault(_ModalLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  return _react2.default.createElement('div', Object.assign({ className: _ModalLayout2.default.modalLayout, style: { minHeight: '400px' } }, props));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/layouts/ModalLayout.js
// module id = 1041
// module chunks = 0